import { DEFAULT_LEAD_STATUSES } from "../../gavion/domain/leads/leadStatusModel";
import type { ConfigurationContextValue } from "./ConfigurationContext";
// GAVION: trade sectors
import { companySectorChoices } from "../../gavion/domain/trades";
import {
  GAVION_DEAL_CATEGORIES,
  GAVION_DEAL_STAGES,
  GAVION_PIPELINE_STATUSES,
} from "../../gavion/domain/deals/dealConfig";
// Import the logos as module assets so Vite resolves their URL relative to the
// JS chunk (import.meta.url), not the current route. A plain "./logos/..." path
// breaks on nested routes like /oauth/consent and under a deployment sub-path.
import darkModeLogo from "./logos/logo_gavion_dark.png";
import lightModeLogo from "./logos/logo_gavion_light.png";

export const defaultDarkModeLogo = darkModeLogo;
export const defaultLightModeLogo = lightModeLogo;

export const defaultCurrency = "CAD";

export const defaultTitle = "Gavion CRM";

// GAVION: sectors are the prospecting trades (spec 03 §1.4)
export const defaultCompanySectors = companySectorChoices("fr");

// GAVION: owner stages, pipeline status and offers (spec 09 §1)
export const defaultDealStages = GAVION_DEAL_STAGES;

export const defaultDealPipelineStatuses = GAVION_PIPELINE_STATUSES;

export const defaultDealCategories = GAVION_DEAL_CATEGORIES;

export const defaultNoteStatuses = [
  { value: "cold", label: "Cold", color: "#7dbde8" },
  { value: "warm", label: "Warm", color: "#e8cb7d" },
  { value: "hot", label: "Hot", color: "#e88b7d" },
  { value: "in-contract", label: "In Contract", color: "#a4e87d" },
];

export const defaultTaskTypes = [
  { value: "none", label: "None" },
  { value: "email", label: "Email" },
  { value: "demo", label: "Demo" },
  { value: "lunch", label: "Lunch" },
  { value: "meeting", label: "Meeting" },
  { value: "follow-up", label: "Follow-up" },
  { value: "thank-you", label: "Thank you" },
  { value: "ship", label: "Ship" },
  { value: "call", label: "Call" },
];

export const defaultConfiguration: ConfigurationContextValue = {
  companySectors: defaultCompanySectors,
  currency: defaultCurrency,
  dealCategories: defaultDealCategories,
  dealPipelineStatuses: defaultDealPipelineStatuses,
  dealStages: defaultDealStages,
  leadStatuses: DEFAULT_LEAD_STATUSES.map((s) => ({ ...s })), // GAVION lead statuses
  noteStatuses: defaultNoteStatuses,
  taskTypes: defaultTaskTypes,
  title: defaultTitle,
  darkModeLogo: defaultDarkModeLogo,
  lightModeLogo: defaultLightModeLogo,
};
